import { ActionName } from './types';

export const createNameFromAction = ({ name, productName, teamName }: ActionName) =>
  [name, productName, teamName].filter(Boolean).join('_');
